import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Executives from "@/pages/Executives";
import Tracker from "@/pages/Tracker";
import Settings from "@/pages/Settings";
import Extension from "@/pages/Extension";
import ClientPortal from "@/pages/ClientPortal";

function Gate({ children, roles, bare }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 font-mono text-sm">
        Loading ApplyPilot…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to={user.role === "client" ? "/portal" : "/"} replace />;
  return bare ? children : <Layout>{children}</Layout>;
}

const STAFF = ["admin", "executive"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Gate roles={STAFF}><Dashboard /></Gate>} />
            <Route path="/clients" element={<Gate roles={STAFF}><Clients /></Gate>} />
            <Route path="/clients/:id" element={<Gate roles={STAFF}><ClientDetail /></Gate>} />
            <Route path="/executives" element={<Gate roles={["admin"]}><Executives /></Gate>} />
            <Route path="/tracker" element={<Gate roles={STAFF}><Tracker /></Gate>} />
            <Route path="/extension" element={<Gate roles={STAFF}><Extension /></Gate>} />
            <Route path="/settings" element={<Gate roles={STAFF}><Settings /></Gate>} />
            <Route path="/portal" element={<Gate roles={["client"]} bare><ClientPortal /></Gate>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
